import { axios, axios2 } from '@/lib/axios';

export const saveSearchApi = (object: any) => {
  const minimal = {
    min_price: object?.min_price,
    max_price: object?.max_price,
    location: object?.location,
  };
  const payload = {
    save_searches: minimal,
  };
  return axios2.post('/customer-api/customer-save-searches', payload);
};
